import { Module } from 'vuex';
import { AuthState, RootState } from '@/store/types';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import { SexTypes } from '@/types/abstract';

const state: AuthState = {
    uid: '',
    phoneNumber: '',
    userType: '',
    sex: SexTypes.None
};

export const auth: Module<AuthState, RootState> = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};